import { routeRolloutRegistry } from '@usealloy/daffy-to-frontend-dashboard-rollout';
import { generatePath, matchPath } from 'react-router-dom';

/**
 * TODO(FRONTEND-608): REMOVE once David's FD counterpart lands in
 * `@usealloy/daffy-to-frontend-dashboard-rollout` (match/convert helpers).
 * Delete this file and switch imports to the jslib; do not extend this shim further.
 *
 * Temporary local path helpers over `routeRolloutRegistry` so we consume David's path pairs
 * without owning match/convert utilities he is actively drafting.
 */

function candidatesForPathname(pathname: string): string[] {
  const candidates = [pathname];
  if (pathname.length > 1 && pathname.endsWith('/')) {
    candidates.push(pathname.slice(0, -1));
  } else if (pathname.length > 1) {
    candidates.push(`${pathname}/`);
  }
  return candidates;
}

/** Map a Daffy path to its registered `/beta/...` path, or null if unregistered. */
export function toFrontendDashboardPath(daffyPathname: string): string | null {
  for (const group of routeRolloutRegistry) {
    for (const path of group.paths) {
      for (const candidate of candidatesForPathname(daffyPathname)) {
        const match = matchPath(path.daffy, candidate);
        if (match) {
          return generatePath(path.frontendDashboard, match.params);
        }
      }
    }
  }
  return null;
}

/**
 * Map a `/beta/...` path to Daffy. Registered paths use the registry; everything else gets a
 * simple `/v3/dashboard/...` prefix.
 */
export function toDaffyPath(frontendDashboardPathname: string): string {
  for (const group of routeRolloutRegistry) {
    for (const path of group.paths) {
      for (const candidate of candidatesForPathname(frontendDashboardPathname)) {
        const match = matchPath(path.frontendDashboard, candidate);
        if (match) {
          return generatePath(path.daffy, match.params);
        }
      }
    }
  }

  const stripped = frontendDashboardPathname.replace(/^\/beta\/?/, '');
  if (stripped === 'v3/dashboard' || stripped.startsWith('v3/dashboard/')) {
    return `/${stripped}`;
  }
  if (stripped === '') {
    return '/v3/dashboard';
  }
  return `/v3/dashboard/${stripped}`;
}
